module.exports = {"id":"203886","name":"Adrien Trebel","rating":"77","photo":"./data/images/photos/0/203886.png","club":{"name":"RSC Anderlecht","logo":"./data/images/clubs/RSCAnderlecht.png"},"positions":["MC","MDC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AdrienTrebel0.json
// module id = 119
// module chunks = 0